import styled from 'styled-components'

export const SubContainer = styled.div`
  display:flex;
  flex-direction:column;
  align-items:center;
  form{
    display:flex;
    flex-direction:column;
    align-items:center
  }
  h3{
    font-family:'Roboto',sans-serif;
    font-size:18px;
    margin:5px 0;
    text-align:left;
    width:100%;
  }
  a{
    text-decoration:none;
    color:currentColor;
    font-size:12px;
    width:100%;
    text-align:right;
  }
  a:hover{
    text-decoration:underline;
  }
  p{
    font-size:14px;
  }
  span{
    color:black;
    font-weight:800;
    font-size:14px;
  }
`